import React from "react";
import { useParams } from "react-router-dom";
import {
  CallToAction,
  ContactInfo,
  ContentService,
  Layout,
  Newsletter
} from "../components";
import { useService } from "../redux/hooks/hooks";
import PageHero from "../components/common/PageHero";
//import { service1Image } from "../assets";

const Service = () => {
  const { slug } = useParams(); // Accept slug parameter for consistency
  const data = useService();
  return (
    <Layout data={data}>
      <PageHero
        eyebrow="Africa Systems"
        title={data?.hero?.title}
        description={data?.hero?.description}
        image={data?.hero?.image}
      />
      <div className="pt-4 pb-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row w-full gap-8 lg:gap-12">
            <ContentService />
            <div className="w-full md:w-1/3">
              <ContactInfo />
              <div className="flex justify-center pt-8">
                <CallToAction />
              </div>
              <div className="pt-8 md:px-2">
                <Newsletter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Service;